import { AnimatePresence, motion } from "framer-motion";
import { Home, FileText, User2, Settings2, ChartAreaIcon, MessageCircle, Briefcase, FileCheck, Bell, Wallet, Shield, User, LogOut, X, StarIcon } from "lucide-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LogoutManually, LogoutUser, useAppDispatch } from "../../../redux";
import { MdReviews } from "react-icons/md";
import SocialMediaLinks from "../../../components/ui/SocialMediaLinks";

const SidebarComponent = () => {
    const dispatch = useAppDispatch();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const sidebarItems = [
        {
            icon: <Home className="h-5 w-5" />,
            label: "Dashboard",
            path: "/clients",
            align: "center",
        },
        {
            icon: <FileText className="h-5 w-5" />,
            label: "Post a Job: Quote or Hire Local",
            path: "/clients/postajob",
            align: "center",
        },
        {
            icon: <FileText className="h-5 w-5" />,
            label: "Post a Job: Quote or Hire International",
            path: "/clients/postajob/international",
            align: "left",
        },
        {
            icon: <FileText className="h-5 w-5" />,
            label: "Find your local professionals",
            path: "/local-professionals",
            align: "center",
        },
        {
            icon: <FileText className="h-5 w-5" />,
            label: "Find your international professionals",
            path: "/professional-international",
            align: "center",
        },

        {
            icon: <User2 className="h-5 w-5" />,
            label: "My Profile",
            path: "/clients/profile",
            align: "left",
        },
        {
            icon: <User className="h-5 w-5" />,
            label: "Profile Settings",
            path: "/clients/profilesettings",
            align: "left",
        },

        {
            icon: <User className="h-5 w-5" />,
            label: "Report",
            path: "/clients/reports",
            align: "left",
        },

        {
            icon: <Settings2 className="h-5 w-5" />,
            label: "My Settings",
            path: "/clients/settings",
            align: "left",
        },

        {
            icon: <StarIcon className="h-5 w-5" />,
            label: "Favorites",
            path: "/clients/favorites",
            align: "left",
        },

        {
            icon: <ChartAreaIcon className="h-5 w-5" />,
            label: "Progress",
            path: "/clients/progress",
            align: "left",
        },
        {
            icon: <MessageCircle className="h-5 w-5" />,
            label: "Message or Video Call",
            path: "/clients/MessageAndVideoCall",
            align: "left",
        },
        {
            icon: <FileCheck className="h-5 w-5" />,
            label: "My Orders",
            path: "/clients/myorders",
            align: "left",
        },
        {
            icon: <MdReviews className="h-5 w-5" />,
            label: "Reviews",
            path: "/clients/reviews",
            align: "left",
        },
        {
            icon: <Bell className="h-5 w-5" />,
            label: "My Offers",
            path: "/clients/myoffers",
            align: "left",
        },
        {
            icon: <Wallet className="h-5 w-5" />,
            label: "Wallet",
            path: "/clients/Wallet",
            align: "left",
        },
        {
            icon: <Shield className="h-5 w-5" />,
            label: "Support tickets",
            path: "/clients/support",
            align: "left",
        },
        {
            icon: <LogOut className="h-5 w-5" />,
            label: "Log Out",
            path: "/logout",
            align: "left",
        },
    ];
    const handleLogout = async () => {
        try {
            const response = await dispatch(LogoutUser({})).unwrap();
        } catch (error: any) {
            if (error === 401) {
                dispatch(LogoutManually());
            }
        }
    };
    const StoreLinks = () => (
        <div className="flex justify-center gap-2 pt-6 px-4">
            <a
                href="https://play.google.com/store/apps/details?id=com.kokobeo"
                className="w-1/2"
            >
                <img
                    src="https://texttofloss.com/wp-content/uploads/2021/01/Google-Play-Store-Button.png"
                    alt="Get it on Google Play"
                    className="w-full h-auto rounded-md hover:opacity-90 transition-opacity"
                    style={{ maxWidth: "160px", height: "50px", objectFit: "contain" }}
                />
            </a>
            <a href="https://apps.apple.com/app/kokobeo" className="w-1/2">
                <img
                    src="https://e7.pngegg.com/pngimages/422/842/png-clipart-apple-store-logo-app-store-android-google-play-get-started-now-button-text-logo.png"
                    alt="Download on App Store"
                    className="w-full h-auto rounded-md hover:opacity-90 transition-opacity"
                    style={{ maxWidth: "160px", height: "50px", objectFit: "contain" }}
                />
            </a>
        </div>
    );
    const SocialIcons = () => (
        <SocialMediaLinks className="flex justify-center space-x-4 pt-4 px-4 pb-6" iconSize="h-4 w-4" />
    );
    return (
        <>
            <aside className="hidden lg:block fixed left-0 top-16 bottom-0 w-64 bg-white border-r overflow-y-auto h-[calc(100vh-64px)]">
                <nav className="p-4 space-y-1 h-full flex flex-col">
                    <div className="flex-1 overflow-y-auto">
                        {sidebarItems.map((item, index) => item.path === "/logout" ?
                            <button
                                key={index}
                                onClick={handleLogout}
                                className="flex w-full items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors text-gray-600 hover:bg-gray-50">
                                {item.icon}
                                <span>{item.label}</span>
                            </button> : (
                                <Link
                                    key={index}
                                    to={item.path}
                                    className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-colors ${location.pathname === item.path
                                        ? "text-blue-600 bg-blue-50 font-medium"
                                        : "text-gray-600 hover:bg-gray-50"
                                        } ${item.align === "center" ? "justify-center-important" : ""
                                        }`}
                                >
                                    <span
                                        className="flex items-center gap-3"
                                        style={
                                            item.align === "center"
                                                ? { justifyContent: "center !important" }
                                                : { justifyContent: "flex-start" }
                                        }
                                    >
                                        {item.icon}
                                        {item.label}
                                    </span>
                                </Link>
                            ))}
                    </div>
                    <div className="mt-auto">
                        <StoreLinks />
                        <SocialIcons />
                    </div>
                </nav>
            </aside>
            <AnimatePresence>
                {isMobileMenuOpen && (
                    <>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setIsMobileMenuOpen(false)}
                            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden"
                        />
                        <motion.aside
                            initial={{ x: "-100%" }}
                            animate={{ x: 0 }}
                            exit={{ x: "-100%" }}
                            transition={{ type: "spring", bounce: 0, duration: 0.4 }}
                            className="fixed inset-y-0 left-0 w-full max-w-xs bg-white shadow-xl z-50 lg:hidden overflow-y-auto h-[calc(100vh-64px)]"
                        >
                            <div className="p-4 h-full flex flex-col">
                                <div className="flex items-center justify-between mb-6">
                                    <div className="flex items-center gap-3">
                                        <img
                                            src="https://assests.netlify.app/assets/images/logo.png"
                                            alt="Logo"
                                            className="h-8 w-8"
                                        />
                                        <span className="text-blue-600 text-lg font-bold">
                                            Kokobeo
                                        </span>
                                    </div>
                                    <button
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
                                    >
                                        <X className="h-6 w-6" />
                                    </button>
                                </div>
                                <nav className="space-y-1 flex-1 overflow-y-auto">
                                    {sidebarItems.map((item, index) => item.path === "/logout" ? (
                                        <button
                                            key={index}
                                            onClick={handleLogout}
                                            className="flex w-full items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors text-gray-600 hover:bg-gray-50">
                                            {item.icon}
                                            <span>{item.label}</span>
                                        </button>
                                    ) : (
                                        <Link
                                            key={index}
                                            to={item.path}
                                            className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-colors ${location.pathname === item.path
                                                ? "text-blue-600 bg-blue-50 font-medium"
                                                : "text-gray-600 hover:bg-gray-50"
                                                } ${item.align === "center"
                                                    ? "justify-center-important"
                                                    : ""
                                                }`}
                                            style={
                                                item.align === "center"
                                                    ? { justifyContent: "center !important" }
                                                    : { justifyContent: "flex-start" }
                                            }
                                            onClick={() => setIsMobileMenuOpen(false)}
                                        >
                                            <span className="flex items-center gap-3">
                                                {item.icon}
                                                {item.label}
                                            </span>
                                        </Link>
                                    ))}
                                </nav>
                                <div className="mt-auto">
                                    <StoreLinks />
                                    <SocialIcons />
                                </div>
                            </div>
                        </motion.aside>
                    </>
                )}
            </AnimatePresence>
        </>
    );
};

export default SidebarComponent;